/*
  This is only an initializer.
  Constructs the different active Academy controllers during the AMD callback
*/
define('lib/Podio.Academy',['require','lib/Podio.Config','lib/GlobalEventBus','controllers/academy/ItemIntroductionAcademyController'],function(require) {
  var podioConfig = require('lib/Podio.Config');
  var globalEvent = require('lib/GlobalEventBus');
  var ItemIntroduction = require('controllers/academy/ItemIntroductionAcademyController');
  if (!podioConfig.user || podioConfig.user.splitTests['onboarding_ux'] === 'experiment') {
    // There can be no academy if we are not logged in or if the user is
    // a part of the new UX experiment to remove Academy
    return;
  }

  var itemIntroductionController;

  // Only construct on the first global eventbus 'open' trigger
  globalEvent.on('academy.open.itemIntroduction', function () {
    // TODO: Lazy load bundle before constructing

    if (typeof itemIntroductionController === 'undefined') {
      itemIntroductionController = new ItemIntroduction();
    }

    if (!itemIntroductionController.isCompleted() && !itemIntroductionController.isDismissed()) {
      itemIntroductionController.openView.apply(itemIntroductionController, arguments);
    }
  });
});

